import { useEffect, useState } from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from '@mui/material';
import {useLocation} from "react-router-dom";


const DriverListDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled, isFetchingDriverList, userListForDropdown, listAllUsersForDropdown, isFetchingAllUsersForDropdown,
        getOrganizationDriverList, orgDriverList
    } = props;

    const theme = useTheme();
    const location = useLocation();

    const [driverListData, setDriverListData] = useState([]);
    const [inputValue, setInputValue] = useState("");

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const storedOrgIdFromRBACForBusiness = rbacStorage?.state?.currentProfile?.orgId || null;
    const orgIdFromUrlForPortEmployee = new URLSearchParams(location.search).get("org_uid");
    

    useEffect(() => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee; 

        if (organizationId) {
            const parameters = {orgUID: organizationId};
            getOrganizationDriverList(parameters);

        } else if (!organizationId) {
            listAllUsersForDropdown();
        }
    }, [storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee])

    useEffect(() => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (organizationId && orgDriverList?.length > 0) {
            setDriverListData(orgDriverList);

        } else if (!organizationId && userListForDropdown?.length > 0) {
            setDriverListData(userListForDropdown);
        }
    }, [userListForDropdown, orgDriverList, storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee])


    const handleChange = (value) => {
        onChange(value);
    }
    

    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={driverListData}
                getOptionLabel={(option) => `${option?.user_info?.[0].firstname} ${(option?.user_info?.[0].middlename) ? option?.user_info?.[0].middlename : ""} ${option?.user_info?.[0].lastname}` || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={value}
                loading={isFetchingDriverList || isFetchingAllUsersForDropdown}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Driver not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search driver"
                        slotProps={{
                            input: {
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {(isFetchingDriverList || isFetchingAllUsersForDropdown)? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default DriverListDropdownComponent